import { api } from '@/api'

async function validateCredentials (credentials) {
  if ((credentials.cadMed || credentials.codConveniada || credentials.numeroExame || credentials.rotaUsername) && credentials.password) {
    const response = await api.post('auth/validate-credentials', credentials)
    return response.data
  } else {
    return {
      success: false,
      message: 'Faça login novamente'
    }
  }
}

async function resendPassword (identifier) {
  if (identifier.cadMed || identifier.codConveniada) {
    const response = await api.post('auth/resend-password', identifier)
    return response.data
  } else {
    return {
      success: false,
      message: 'Erro ao enviar nova senha'
    }
  }
}

export {
  validateCredentials,
  resendPassword
}
